import { render, staticRenderFns } from "./lazyImg.vue?vue&type=template&id=960b775c&"
import script from "./lazyImg.vue?vue&type=script&lang=js&"
export * from "./lazyImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports